/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
import { Fragment, useEffect, useState } from 'react';
import { Disclosure } from '@headlessui/react';
import { useConnect, useAccount } from 'wagmi';
import { Bars3Icon, XMarkIcon, WalletIcon } from '@heroicons/react/24/outline';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import logo from 'modules/common/assests/images/Logo-Gac-Registred-150x150.png';
import metamask from 'modules/common/assests/images/metamaskIcon.png';
import walletConnectIco from 'modules/common/assests/images/walletConnectIcon.svg';
import coinbaseWallet from 'modules/common/assests/images/coinbaseWalletIcon.svg';
import creditcard from 'modules/common/assests/images/credit-card.png';
import cryptoWallet from 'modules/common/assests/images/bitcoin-wallet.png';
import succussAnimation from 'modules/common/assests/animations/success.json';
import Lottie from 'lottie-react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getNFTsSlice } from 'modules/home/slice';
import { getAdminsSlice } from 'modules/admin/slice';
import { checkConnectivity } from 'modules/home/selectors';
import { getAdminsList } from 'modules/admin/selectors';
import { getMasterAdmin } from 'modules/admin/functions';
import WalletModal from '../modal';
import 'react-tooltip/dist/react-tooltip.css';

const payments = [
  {
    id: 1,
    name: 'Pay with Card',
  },
  {
    id: 2,
    name: 'Pay with Wallet',
  },
];

export default function Navbar() {
  const dispatch = useDispatch();
  const { connectors, connectAsync } = useConnect();
  const currentAccount = useSelector(checkConnectivity);
  const adminsList = useSelector(getAdminsList);

  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState(2);
  const [steps, setSteps] = useState([
    { id: 1, name: 'Step 1', href: '#', status: 'complete' },
    { id: 2, name: 'Step 2', href: '#', status: 'current' },
    { id: 3, name: 'Step 3', href: '#', status: 'upcoming' },
  ]);

  const fiatConnection = localStorage.getItem('type');

  const walletConnect = async (connector) => {
    const { account } = await connectAsync({ connector });
    return account;
  };

  function openModal() {
    setIsOpen(true);
  }

  const iconList = (connectorType) => {
    if (connectorType === 'metaMask') {
      return metamask;
    }
    if (connectorType === 'walletConnect') {
      return walletConnectIco;
    }
    if (connectorType === 'coinbaseWallet') {
      return coinbaseWallet;
    }
    if (connectorType === 1) {
      return creditcard;
    }
    if (connectorType === 2) {
      return cryptoWallet;
    }
    return '';
  };
  const checkIfWalletIsConnect = async () => {
    await Promise.resolve(dispatch(getNFTsSlice.actions.checkConnectivity()));
  };

  const getAdmins = async () => {
    await Promise.resolve(dispatch(getAdminsSlice.actions.getAdmins()));
  };

  const getMaster = async () => {
    await Promise.resolve(dispatch(getAdminsSlice.actions.getMasterAdmin()));
  };

  useEffect(() => {
    checkIfWalletIsConnect();
    getAdmins();
    getMaster();
  }, []);
  return (
    <Disclosure as='nav' className='shadow bg-transparent'>
      {({ open }) => (
        <>
          <div className='max-w-full mx-20 lg:ml-48 px-4 sm:px-6 lg:px-8 lg:py-2'>
            <div className='flex justify-between h-20'>
              <div className='flex'>
                <Link to={'/'}>
                  <div className='flex-shrink-0 flex items-center'>
                    <img
                      className='block lg:hidden h-20 w-auto'
                      src={logo}
                      alt='Workflow'
                    />
                    <img
                      className='hidden lg:block h-20 w-auto'
                      src={logo}
                      alt='Workflow'
                    />
                  </div>
                </Link>
              </div>

              <div>
                {' '}
                <WalletModal
                  setIsOpen={(value) => setIsOpen(value)}
                  isOpen={isOpen}
                  setStep={(value) => setStep(value)}
                  setSteps={(value) => setSteps(value)}
                  steps={steps}
                  title='Connect a wallet'
                >
                  {step === 0 ? (
                    <div>
                      {payments.map((payment) => (
                        <div className='my-4'>
                          <button
                            type='button'
                            key={payment.id}
                            onClick={() => {
                              setStep(payment.id);
                              setSteps([
                                {
                                  id: 1,
                                  name: 'Step 1',
                                  href: '#',
                                  status: 'complete',
                                },
                                {
                                  id: 2,
                                  name: 'Step 2',
                                  href: '#',
                                  status: 'current',
                                },
                                {
                                  id: 3,
                                  name: 'Step 3',
                                  href: '#',
                                  status: 'upcoming',
                                },
                                // { name: 'Step 4', href: '#', status: 'complete' },
                              ]);
                              localStorage.setItem('type', 'wallet');
                            }}
                            className='bg-[#DEF8D6] px-4 py-4 rounded-xl font-medium text-[#0d111c] text-lg w-full flex'
                          >
                            <div>
                              <img
                                src={iconList(payment.id)}
                                alt='wallet'
                                className='h-7 w-12 px-2'
                              />
                            </div>
                            <div className='px-2 text-[#274728] font-bold'>
                              {payment.name}
                            </div>
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : step === 2 ? (
                    <div>
                      {connectors.map((connector) => (
                        <div className='my-4'>
                          <button
                            type='button'
                            key={connector.id}
                            onClick={async () => {
                              const res = await walletConnect(connector);

                              if (res) {
                                setStep(3);
                                setSteps([
                                  {
                                    id: 1,
                                    name: 'Step 1',
                                    href: '#',
                                    status: 'complete',
                                  },
                                  {
                                    id: 2,
                                    name: 'Step 2',
                                    href: '#',
                                    status: 'complete',
                                  },
                                  {
                                    id: 3,
                                    name: 'Step 3',
                                    href: '#',
                                    status: 'current',
                                  },
                                  // { name: 'Step 4', href: '#', status: 'complete' },
                                ]);
                              }
                            }}
                            className='bg-[#DEF8D6] px-4 py-4 rounded-xl font-medium text-[#0d111c] text-lg w-full flex'
                          >
                            <div>
                              <img
                                src={iconList(connector.id)}
                                alt='wallet'
                                className='h-7 w-12 px-2'
                              />
                            </div>
                            <div className='px-2 text-[#274728] font-bold'>
                              {connector.name}
                            </div>
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : step === 3 ? (
                    <Lottie
                      animationData={succussAnimation}
                      loop={false}
                      onComplete={() => {
                        setIsOpen(false);
                      }}
                      onDestroy={() => {
                        setTimeout(() => {
                          setStep(0);
                          window.location.reload();
                        }, 500);
                      }}
                    />
                  ) : (
                    <div className='my-4'>
                      <button
                        type='button'
                        className='bg-[#DEF8D6] px-4 py-4 rounded-xl font-medium text-[#0d111c] text-lg w-full flex'
                        onClick={() => {
                          setStep(3);
                          localStorage.setItem('type', 'card');
                          setSteps([
                            {
                              id: 1,
                              name: 'Step 1',
                              href: '#',
                              status: 'complete',
                            },
                            {
                              id: 2,
                              name: 'Step 2',
                              href: '#',
                              status: 'complete',
                            },
                            {
                              id: 3,
                              name: 'Step 3',
                              href: '#',
                              status: 'current',
                            },
                            // { name: 'Step 4', href: '#', status: 'complete' },
                          ]);
                        }}
                      >
                        <div>
                          <img
                            src={creditcard}
                            alt='wallet'
                            className='h-7 w-12 px-2'
                          />
                        </div>
                        <div className='px-2 text-[#274728] font-bold'>
                          Connect to Card
                        </div>
                      </button>
                      {/* <button
                onClick={async () => {
                  // Replace with your checkout link.
                  const checkoutLinkUrl =
                    'https://withpaper.com/checkout/10ce46d2-97be-40c9-b6b3-39c0509ffa73';
                  await renderPaperCheckoutLink({ checkoutLinkUrl });
                }}
              >
                Buy with Paper
              </button> */}
                    </div>
                  )}

                  {/* */}
                  <div className='text-[#98a1c0] mx-4'>
                    By connecting a wallet, you agree to Green Art Coin{' '}
                    <span className='text-[#40A838] font-medium cursor-pointer'>
                      Terms of Service
                    </span>{' '}
                    and consent to its{' '}
                    <span className='text-[#40A838] font-medium cursor-pointer'>
                      Privacy Policy
                    </span>
                    .
                  </div>
                </WalletModal>
              </div>

              <div className='hidden sm:ml-6 sm:flex sm:items-center'>
                {currentAccount?.connected &&
                adminsList.filter(
                  (data) => data?.wallet === currentAccount?.account
                ).length === 1 ? (
                  <>
                    <div
                      id='connected-address'
                      className='text-white bg-gradient-to-b from-[#274728] to-[#40A838] px-4 py-2 rounded-full flex cursor-default mx-4'
                    >
                      <span>
                        <WalletIcon className='block h-6 w-6 mx-2' />
                      </span>
                      {currentAccount?.account.slice(0, 8)}...
                      {currentAccount?.account.slice(37, 42)}
                      <ReactTooltip
                        anchorId='connected-address'
                        place='bottom'
                        variant='dark'
                        className='rounded-lg bg-transparent'
                        content={currentAccount?.account}
                      />
                    </div>
                    <Link to={currentAccount?.connected ? `/admin` : '/'}>
                      <button className='bg-gradient-to-b from-[#274728] to-[#40A838] p-1 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-0 focus:ring-offset-0 w-auto h-10 px-4 rounded !outline-none ease-in duration-300 mx-4'>
                        Owners
                      </button>
                    </Link>
                    <Link to={currentAccount?.connected ? `/mint-nfts` : '/'}>
                      <button className='bg-gradient-to-b from-[#274728] to-[#40A838] p-1 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-0 focus:ring-offset-0 w-auto h-10 px-4 rounded !outline-none ease-in duration-300 mx-4'>
                        Mint NFTs
                      </button>
                    </Link>
                  </>
                ) : currentAccount?.connected ? (
                  <div />
                ) : fiatConnection === 'card' ? (
                  <button
                    // onClick={connectWallet}
                    onClick={() => {
                      localStorage.removeItem('type');
                      window.location.reload();
                    }}
                    className=' bg-gradient-to-b from-[#274728] to-[#40A838] p-1 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-0 focus:ring-offset-0 w-auto h-10 px-4 rounded !outline-none ease-in duration-300'
                  >
                    Disconnect
                  </button>
                ) : (
                  <button
                    onClick={openModal}
                    type='button'
                    className=' bg-gradient-to-b from-[#274728] to-[#40A838] p-1 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-0 focus:ring-offset-0 w-auto h-10 px-4 rounded !outline-none ease-in duration-300'
                  >
                    <span>Connect Wallet</span>
                  </button>
                )}
              </div>
              <div className='-mr-2 flex items-center sm:hidden'>
                {/* Mobile menu button */}
                <Disclosure.Button className='inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-[#40A838]  hover:bg-transparent focus:outline-none focus:ring-0 focus:ring-offset-0'>
                  <span className='sr-only'>Open main menu</span>
                  {open ? (
                    <XMarkIcon className='block h-6 w-6' aria-hidden='true' />
                  ) : (
                    <Bars3Icon className='block h-6 w-6' aria-hidden='true' />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          <Disclosure.Panel className='sm:hidden'>
            <div className='pt-4 pb-3 border-t border-gray-200 w-full flex justify-center'>
              <div className='flex items-center px-4'>
                {currentAccount?.connected ? (
                  <Link to={currentAccount?.connected ? `/mint-nfts` : '/'}>
                    <Disclosure.Button className='bg-gradient-to-b from-[#274728] to-[#40A838] p-1 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-0 focus:ring-offset-0 w-auto h-10 px-4 rounded !outline-none ease-in duration-300'>
                      Mint NFTs
                    </Disclosure.Button>
                  </Link>
                ) : fiatConnection === 'card' ? (
                  <Disclosure.Button
                    // onClick={connectWallet}
                    onClick={() => {
                      localStorage.removeItem('type');
                      window.location.reload();
                    }}
                    className=' bg-gradient-to-b from-[#274728] to-[#40A838] p-1 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-0 focus:ring-offset-0 w-auto h-10 px-4 rounded !outline-none ease-in duration-300'
                  >
                    Disconnect
                  </Disclosure.Button>
                ) : (
                  <Disclosure.Button
                    onClick={openModal}
                    type='button'
                    className=' bg-gradient-to-b from-[#274728] to-[#40A838] p-1 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white focus:outline-none focus:ring-0 focus:ring-offset-0 w-auto h-10 px-4 rounded !outline-none ease-in duration-300'
                  >
                    <span>Connect Wallet</span>
                  </Disclosure.Button>
                )}
              </div>
              <div className='mt-3 space-y-1'>
                {/* <Disclosure.Button
                  as="a"
                  href="#"
                  className="block px-4 py-2 text-base font-medium text-white hover:text-gray-800 hover:bg-gray-100"
                >
                  Your Profile
                </Disclosure.Button>
                <Disclosure.Button
                  as="a"
                  href="#"
                  className="block px-4 py-2 text-base font-medium text-white hover:text-gray-800 hover:bg-gray-100"
                >
                  Settings
                </Disclosure.Button>
                <Disclosure.Button
                  as="a"
                  href="#"
                  className="block px-4 py-2 text-base font-medium text-white hover:text-gray-800 hover:bg-gray-100"
                >
                  Sign out
                </Disclosure.Button> */}
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
